<div
    class="agpr-container"
    [agprLoading]="loading"
>
    <div class="agpr-center" *ngIf="selectedAccount">
        <div class="agpr-accountPrefs-header">
            <h2 class="agpr-accountPrefs-header-name">{{ selectedAccount.name }}
                <span *ngIf="!selectedAccount.active" class="agpr-accountPrefs-header-name-inactive">(deactivated)</span>
            </h2>
            <div class="agpr-accountPrefs-header-id-container">
                <div class="agpr-accountPrefs-header-id-label">
                    {{ 'AMT.header.accountNumber' | localize}}
                </div>
                <div
                    class="agpr-accountPrefs-header-id"
                    [ngClass]="{'agpr-accountPrefs-header-id-neptuneOnly': selectedAccount?.neptuneOnly}"
                >
                    <span [agprTooltip]="selectedAccount?.neptuneOnly ? 'AMT.header.neptuneOnly.tooltip' : null">{{ selectedAccount.id }}</span>
                    <a
                        class="agpr-accountPrefs-header-id-pendoLink"
                        [href]="`https://app.pendo.io/s/5707616250822656/dashboards/OQphEXOJ956N2nTwZXfVrrj67II?dateType=180&accountId=${selectedAccount.id}`"
                        target="_blank"
                        [agprTooltip]="'AMT.header.pendoLink.tooltip'"
                        [tooltipAllowsHtml]="true"
                        tooltipPosition="top"
                        tooltipStyleClass="agpr-tooltip-alwaysBeAbove"
                    >
                        <span class="fa-duotone fa-regular fa-magnifying-glass-chart"></span>
                    </a>
                </div>
            </div>
        </div>
        <agpr-tabs
            #tabs
            [id]="'agpr_accountPrefs_tabs'"
            class="agpr-accountPrefs-tabs"
            [selectedTabIndex]="selectedTabIndex"
            (selectedTabIndexChange)="changeTabs($event)"
        >
            <div
                *ngIf="selectedAccount.id && !selectedAccount.active"
                class="agpr-accountPrefs-headerToolbar"
            >
                <agpr-message
                    *ngIf="!selectedAccount.active"
                    [severity]="messageSeverityEnum.info"
                >
                    {{ 'AMT.header.inactiveMsg' | localize }}
                </agpr-message>
            </div>
            <!-- General Tab -->
            <agpr-tab
                [id]="'agpr_accountPrefs_tab_general'"
                class="agpr_accountPrefs_tab"
                heading="AMT.tab.general"
            >
                <!-- Account Details -->
                <agpr-panel
                    *ngIf="selectedAccount"
                    header="AMT.accountDetails"
                >
                    <div class="agpr-accountPrefs-details">
                        <div
                            class="agpr-accountPrefs-account"
                            role="radiogroup"
                            [attr.aria-label]="'AMT.accountDetails.type' | localize"
                        >
                            <agpr-radio
                                [id]="id + '_clientAccountType'"
                                label="AMT.accountDetails.client"
                                hiddenLabel="AMT.accountDetails.client"
                                [(ngModel)]="selectedAccount.internal"
                                [value]="false"
                                [disabled]="isReadOnly || !selectedAccount.neptuneOnly"
                            ></agpr-radio>
                            <agpr-radio
                                [id]="id + '_internalAccountType'"
                                label="AMT.accountDetails.internal"
                                hiddenLabel="AMT.accountDetails.internal"
                                [(ngModel)]="selectedAccount.internal"
                                [value]="true"
                                [disabled]="isReadOnly || !selectedAccount.neptuneOnly"
                            ></agpr-radio>
                        </div>
                        <div class="agpr-accountPrefs-name">
                            <agpr-text-input
                                [id]="id + '_name'"
                                label="AMT.accountDetails.name"
                                [(ngModel)]="selectedAccount.name"
                                [disabled]="isReadOnly || !selectedAccount.neptuneOnly"
                            ></agpr-text-input>
                        </div>
                        <div class="agpr-accountPrefs-dateRange">
                            <div class="agpr-accountPrefs-dateRange-section">
                                <label>{{ 'AMT.accountDetails.startDate' | localize }}</label>
                                <agpr-date-picker
                                    #calendarStart
                                    [id]="id +'_startInput'"
                                    [(ngModel)]="selectedAccount.startDate"
                                    (ngModelChange)="onChangeStartDate($event)"
                                    [ariaLabelledBy]="id + '_startDateLabel'"
                                    [disabled]="isReadOnly || !selectedAccount.neptuneOnly"
                                    [maxDate]="selectedAccount.expiryDate?.toDate()"
                                >
                                </agpr-date-picker>
                            </div>
                            <div class="agpr-accountPrefs-dateRange-section">
                                <label>{{ 'AMT.accountDetails.startTime' | localize }} (UTC)</label>
                                <agpr-time-picker
                                    [id]="id + '_startTime'"
                                    [(ngModel)]="startTime"
                                    [showTimeZoneSelector]="false"
                                    [header]="'time' | localize"
                                    [disabled]="isReadOnly || !selectedAccount.neptuneOnly"
                                    [maxTime]="isContractSameDay() ? expireTime : null"
                                    (changeHour)="startOrEndTimeChanged()"
                                    (changeMinute)="startOrEndTimeChanged()"
                                    (changeMeridian)="startOrEndTimeChanged()"
                                    (boundaryReached)="onContractTimeBoundaryReached()"
                                ></agpr-time-picker>
                            </div>
                        </div>
                        <div class="agpr-accountPrefs-dateRange">
                            <div class="agpr-accountPrefs-dateRange-section">
                                <label class="agpr-accountPrefs-dateRange--topM">{{ 'AMT.accountDetails.endDate' | localize }}</label>
                                <agpr-date-picker
                                    #calendarExpire
                                    [id]="id +'_expireInput'"
                                    [(ngModel)]="selectedAccount.expiryDate"
                                    (ngModelChange)="onChangeExpireDate($event)"
                                    [ariaLabelledBy]="id + '_expireDateLabel'"
                                    [disabled]="isReadOnly || !selectedAccount.neptuneOnly"
                                    [minDate]="selectedAccount.startDate?.toDate()"
                                >
                                </agpr-date-picker>
                            </div>
                            <div class="agpr-accountPrefs-dateRange-section">
                                <label>{{ 'AMT.accountDetails.endTime' | localize }} (UTC)</label>
                                <agpr-time-picker
                                    [id]="id + '_expireTime'"
                                    [(ngModel)]="expireTime"
                                    [showTimeZoneSelector]="false"
                                    [header]="'time' | localize"
                                    [disabled]="isReadOnly || !selectedAccount.neptuneOnly"
                                    [minTime]="isContractSameDay() ? startTime : null"
                                    (changeHour)="startOrEndTimeChanged()"
                                    (changeMinute)="startOrEndTimeChanged()"
                                    (changeMeridian)="startOrEndTimeChanged()"
                                    (boundaryReached)="onContractTimeBoundaryReached()"
                                ></agpr-time-picker>
                            </div>
                        </div>
                        @if (hasInvalidContractTimeRange || hasContractTimeBoundaryWarning) {
                            <agpr-form-message>
                                {{ 'AMT.accountDetails.dateRange.invalidTime' | localize }}
                            </agpr-form-message>
                        }
                        @if (selectedAccount.active && !selectedAccount.isExpiryDatePast && lastAutoRenewDate) {
                            <div class="agpr-accountPrefs-autoRenewAnnotation">
                                {{ 'AMT.accountDetails.autoRenew.renewedOn' | localize }} {{ lastAutoRenewDate }}
                            </div>
                        }
                        <div class="agpr-accountPrefs-autoRenew">
                            <agpr-checkbox
                                [id]="id + '_autoRenew'"
                                [(ngModel)]="selectedAccount.autoRenew"
                                [binary]="true"
                                [label]="'AMT.accountDetails.autoRenew'"
                                [infoCircleTooltip]="'AMT.accountDetails.autoRenew.info'"
                                [disabled]="isReadOnly || !selectedAccount.neptuneOnly"
                            ></agpr-checkbox>
                        </div>
                        <div class="agpr-accountPrefs-contentLibrary" *ngIf="contentLibraryStorageSettings">
                            <h3>{{ 'Common.contentLibrary.manageDialog.library.AMT.label' | localize }}</h3>
                            <div class="agpr-accountPrefs-contentLibrary-twoColumnGrid">
                                <div class="agpr-accountPrefs-contentLibrary-twoColumnGrid-column">
                                    <agpr-number-input
                                        [id]="id + '_contentStorageLimitBytes'"
                                        [(ngModel)]="contentLibraryStorageSettings.contentStorageLimitBytes"
                                        [disabled]="isReadOnly"
                                        label='Common.contentLibrary.manageDialog.library.AMT.message'
                                        [min]="0"
                                        [max]="100"
                                        [allowedDecimalUnits]="3"
                                    ></agpr-number-input>
                                </div>
                                <div class="agpr-accountPrefs-contentLibrary-twoColumnGrid-column">
                                    <agpr-number-input
                                        [id]="id + '_contentUsedBytes'"
                                        [ngModel]="contentLibraryStorageSettings.contentUsedBytes.toFixed(3)"
                                        [disabled]="true"
                                        label='Common.contentLibrary.manageDialog.library.AMT.storage.used'
                                        [min]="0"
                                        [max]="100"
                                    ></agpr-number-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- TODO: Location, Account Manager(Client only), Customer Support Specialist(Client only) -->
                </agpr-panel>
                <!-- Account Settings -->
                <agpr-panel
                    *ngIf="selectedAccount"
                    header="AMT.accountSettings"
                    [marginTop]="20"
                >
                    <div class="agpr-accountPrefs-settings">
                        <div class="left">
                            <h5 class="agpr-headerH3-dark">Account Type</h5>
                            <div class="left-content">
                                <div class="agpr-accountPrefs-settings-agilityPlatform">
                                    <agpr-checkbox
                                        [id]="id + '_agilityPlatform_checkbox'"
                                        label="AMT.accountSettings.agility"
                                        hiddenLabel="AMT.accountSettings.agility"
                                        [binary]="true"
                                        [(ngModel)]="selectedAccount.hasUiAccess"
                                        (onChange)="hasUiAccessChanged($event)"
                                    ></agpr-checkbox>

                                    @if (selectedAccount.hasUiAccess || true) {
                                        <div
                                            class="agpr-accountPrefs-type"
                                            role="radiogroup"
                                            [attr.aria-label]="'AMT.accountSettings.agility' | localize"
                                        >
                                            <agpr-radio
                                                [id]="id + '_platformAccountType_standard'"
                                                label="AMT.accountSettings.agility.standard"
                                                hiddenLabel="AMT.accountSettings.agility.standard"
                                                [(ngModel)]="isPartnerResellerAccount"
                                                [value]="false"
                                                (ngModelChange)="isPartnerResellerAccountChanged($event)"
                                                [disabled]="hasClassicTargeting || isReadOnly || !selectedAccount.neptuneOnly"
                                            >
                                            </agpr-radio>
                                            <agpr-radio
                                                [id]="id + '_platformAccountType_partnerReseller'"
                                                label="AMT.general.partnerReseller"
                                                hiddenLabel="AMT.general.partnerReseller"
                                                [(ngModel)]="isPartnerResellerAccount"
                                                [value]="true"
                                                (ngModelChange)="isPartnerResellerAccountChanged($event)"
                                                [disabled]="hasClassicTargeting || isReadOnly || !selectedAccount.neptuneOnly"
                                            ></agpr-radio>
                                            @if (isPartnerResellerAccount) {
                                                <div [ngClass]="{'visible': isPartnerResellerAccount}" class="agpr-accountPrefs-partnerReseller">
                                                    <agpr-dropdown
                                                        [id]="id + '_partnerResellerId'"
                                                        placeholder="AMT.general.partnerReseller.placeholder"
                                                        [options]="partnerResellerDropdownOptions"
                                                        [(ngModel)]="selectedPartnerReseller"
                                                        (ngModelChange)="partnerResellerChanged($event)"
                                                        [disabled]="hasClassicTargeting || isReadOnly || !selectedAccount.neptuneOnly"
                                                        ariaLabel="AMT.general.partnerReseller"
                                                    ></agpr-dropdown>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>

                                <!-- Media Database APIs-->
                                <div class="agpr-accountPrefs-settings-mediaDatabaseApis">
                                    <agpr-checkbox
                                        [id]="id + '_mediaDatabaseApis_checkbox'"
                                        label="AMT.accountSettings.mediaDatabaseApis"
                                        hiddenLabel="AMT.accountSettings.mediaDatabaseApis"
                                        [binary]="true"
                                        [(ngModel)]="hasMediaDatabaseApis"
                                        (onChange)="hasMediaDatabaseApiChanged($event)"
                                    ></agpr-checkbox>

                                    @if(hasMediaDatabaseApis) {
                                        <div class="agpr-accountPrefs-settings-mediaDatabaseApis-dropdowm">
                                            <agpr-dropdown
                                                [id]="id + 'mediaDatabaseApi_partnerResellerId'"
                                                placeholder="AMT.general.partnerReseller.placeholder"
                                                [options]="mediaDatabaseApisDropdownOptions"
                                                [(ngModel)]="selectedMediaDatabaseApiReseller"
                                                ariaLabel="AMT.general.mediaDatabaseApiPartnerReseller"
                                                (ngModelChange)="mediaDbApiPartnerResellerChanged($event)"
                                            ></agpr-dropdown>
                                        </div>
                                    }
                                </div>
                                <!-- Media Monitoring APIs-->
                                <div class="agpr-accountPrefs-settings-mediaDatabaseApis">
                                    <agpr-checkbox
                                        [id]="id + '_mediaMonitoringApis_checkbox'"
                                        label="AMT.accountSettings.mediaMonitoringApis"
                                        hiddenLabel="AMT.accountSettings.mediaMonitoringApis"
                                        [binary]="true"
                                        [(ngModel)]="hasMediaMonitoringApis"
                                        (onChange)="hasMediaMonitoringApiChanged($event)"
                                    ></agpr-checkbox>
                                </div>
                            </div>
                            <h5 class="agpr-headerH3-dark">{{ 'AMT.accountSettings.accountData' | localize }}</h5>
                            <div class="left-content">
                                <agpr-checkbox
                                    [id]="id + '_preserveData'"
                                    [(ngModel)]="selectedAccount.preserveData"
                                    [binary]="true"
                                    [label]="'AMT.accountSettings.preserveData'"
                                    [infoCircleTooltip]="'AMT.accountSettings.preserveData.info'"
                                    [disabled]="isReadOnly || disablePreserveData"
                                    (onChange)="showPreserveDataWarning()"
                                >
                                </agpr-checkbox>
                                <div>
                                    {{ 'AMT.accountSettings.preserveData.dateLabel' | localize }} {{dataPreserveExpireDate}}
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <h5
                                [id]="id + '_features'"
                                class="agpr-headerH3-dark"
                            >
                                {{ 'AMT.accountSettings.features' | localize }}
                            </h5>
                            <div class="right-content">
                                <ul aria-labelledby="amt_accountSettings_features">
                                    @for (accountPermission of allAccountPermissions; track accountPermission) {
                                        <li>
                                            <agpr-checkbox
                                                [value]="accountPermission.enum"
                                                [id]="id + '_permission_' + accountPermission.enum"
                                                [(ngModel)]="selectedAccount.permissions"
                                                [label]="accountPermission.displayString"
                                                [disabled]="isReadOnly || !selectedAccount.hasUiAccess"
                                                (onChange)="togglePreferenceVisibilities($event, accountPermission.enum)"
                                            >
                                            </agpr-checkbox>
                                            @if (accountPermission?.children) {
                                                <div
                                                    class="agpr-accountPrefs-type">
                                                    @for (childPermission of accountPermission.children; track childPermission) {
                                                        <agpr-checkbox
                                                            [value]="childPermission.enum"
                                                            [id]="id + '_permission_' + childPermission.enum"
                                                            [(ngModel)]="selectedAccount.permissions"
                                                            [label]="childPermission.displayString"
                                                            [disabled]="isReadOnly
                                                                || !selectedAccount.hasUiAccess
                                                                || childPermission?.disabled?.(selectedAccount.permissions)"
                                                            (onChange)="togglePreferenceVisibilities($event, childPermission.enum)"
                                                        >
                                                        </agpr-checkbox>
                                                        @if (
                                                            childPermission.enum === servicesEnum.visibilityIntelligence
                                                            && selectedAccount.permissions.includes(servicesEnum.visibilityIntelligence)
                                                            && agentConfiguration
                                                        ) {
                                                            <div class="agpr-accountPrefs-type-subField">
                                                                <agpr-number-input
                                                                    [id]="id + '_visibilityIntelligence_activeQuestionLimit'"
                                                                    [(ngModel)]="agentConfiguration.monitorQuestionLimit"
                                                                    [label]="'AMT.permission.visibilityIntelligence.activeQuestionLimit.label'"
                                                                    [tooltip]="'AMT.permission.visibilityIntelligence.activeQuestionLimit.tooltip'"
                                                                    [min]="0"
                                                                    [max]="maxMonitorQuestionLimit"
                                                                    [integerOnly]="true"
                                                                    [defaultValue]="0"
                                                                    [disabled]="isReadOnly || !selectedAccount.hasUiAccess"
                                                                ></agpr-number-input>
                                                            </div>
                                                        }
                                                    }
                                                </div>
                                            }
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </agpr-panel>
                <!-- Media Database APIs-->
                @if (selectedAccount.permissions.includes(servicesEnum.mediaDatabaseApi)) {
                    <agpr-panel
                        header="AMT.accountSettings.mediaDatabaseApis"
                        [marginTop]="20"
                    >
                        <div class="agpr-accountPrefs-mediaDatabaseApiCard">
                            <div class="agpr-accountPrefs-mediaDatabaseApiCard-titleContainer">
                                <span class="agpr-accountPrefs-mediaDatabaseApiCard-title">
                                    {{ 'AMT.accountSettings.mediaDatabaseApis.partnerReseller' | localize}}
                                </span>
                            </div>
                            <div class="agpr-accountPrefs-mediaDatabaseApiCard-content">
                                {{ selectedMediaDatabaseApiReseller?.label }}
                            </div>

                            @if (accessToken) {
                                <div class="agpr-accountPrefs-mediaDatabaseApiCard-titleContainer">
                                    <span class="agpr-accountPrefs-mediaDatabaseApiCard-title">
                                        {{ 'AMT.accountSettings.mediaDatabaseApis.accessToken' | localize}}
                                    </span>
                                    <agpr-button
                                        class="agpr-accountPrefs-copyIcon"
                                        [style]="buttonTypes.icon"
                                        icon="fa-kit-duotone fa-agpr-copy"
                                        tooltip="AMT.accountSettings.mediaDatabaseApis.accessToken.copy"
                                        tooltipPosition="top"
                                        (click)="copy(accessToken)"
                                    ></agpr-button>
                                </div>
                                <div class="agpr-accountPrefs-mediaDatabaseApiCard-content">
                                    {{ accessToken }}
                                </div>
                            }

                            @if (clientId) {
                                <div class="agpr-accountPrefs-mediaDatabaseApiCard-titleContainer">
                                    <span class="agpr-accountPrefs-mediaDatabaseApiCard-title">
                                        {{ 'AMT.accountSettings.mediaDatabaseApis.clientId' | localize}}
                                    </span>
                                    <agpr-button
                                        class="agpr-accountPrefs-copyIcon"
                                        [style]="buttonTypes.icon"
                                        icon="fa-kit-duotone fa-agpr-copy"
                                        tooltip="AMT.accountSettings.mediaDatabaseApis.clientId.copy"
                                        tooltipPosition="top"
                                        (click)="copy(clientId)"
                                    ></agpr-button>
                                </div>
                                <div class="agpr-accountPrefs-mediaDatabaseApiCard-content">
                                    {{ clientId }}
                                </div>
                            }

                        </div>
                        <agpr-include-exclude-chips
                            id="accountManagement.geoRestrictions"
                            headerLabel="AMT.targeting.regionalRestrictions"
                            [disabled]="isReadOnly"
                            [placeholder]="'Discover.targeting.searchFieldLabels.search.placeholder'"
                            [autocompleteOptions]="{
                                suggestionsFetcher: journodexRegionsService.searchGeographicLocations.bind(journodexRegionsService)
                            }"
                            idField="collectionId"
                            labelLookupField="displayString"
                            [showIncludeAll]="false"
                            [(idModel)]="targetingPreferences.geography"
                            [lookupById]="journodexRegionsService.getByGeographyIds.bind(journodexRegionsService)"
                            (browseAll)="openRegionBrowser($event)"
                            headingLevel="4"
                        ></agpr-include-exclude-chips>
                    </agpr-panel>
                }
                <!-- TODO : add again if needed, currently only for journodex-manager anyway -->
                <!--p-panel header = "Permissions" [toggleable]="true" *ngIf = "selectedAccount && selectedUser">
                    <agpr-permission-management>

                    </agpr-permission-management>
                </p-panel-->
                <!-- Multi-Factor Authentication -->
                <agpr-panel
                    header="Mfa.amt.heading"
                    tooltip="Mfa.amt.tooltip"
                    [marginTop]="20"
                >
                    <agpr-checkbox
                        [id]="id + '_mfaEnable'"
                        [binary]="true"
                        label="Mfa.umt.enable"
                        [(ngModel)]="selectedAccount.isMfaEnabled"
                        (ngModelChange)="toggleMfa()"
                        [disabled]="ssoEnabled"
                    ></agpr-checkbox>
                    <div
                        *ngIf="selectedAccount.isMfaEnabled"
                        class="agpr-accountPrefs-indent"
                    >
                        <div role="radiogroup">
                            <agpr-radio
                                [id]="id + '_mfaEnable_optional'"
                                label="Mfa.umt.enable.optional"
                                [(ngModel)]="selectedAccount.isMfaRequired"
                                [value]="false"
                            ></agpr-radio>
                            <agpr-radio
                                [id]="id + '_mfaEnable_mandatory'"
                                label="Mfa.umt.enable.required"
                                [(ngModel)]="selectedAccount.isMfaRequired"
                                [value]="true"
                            ></agpr-radio>
                        </div>
                        <div
                            role="group"
                            class="agpr-accountPrefs-mfa-availableMethods-container"
                            [attr.aria-label]="'Mfa.umt.availableMethods' | localize "
                        >
                            <label class="agpr-accountPrefs-mfa-availableMethods-label">
                                {{  'Mfa.umt.availableMethods' | localize }}
                            </label>
                            <agpr-checkbox
                                [id]="id + '_mfMethod_email'"
                                [label]="'Mfa.'+ mfaTypesEnum.email"
                                [value]="mfaTypesEnum.email"
                                [(ngModel)]="selectedAccount.enabledMfaTypes"
                            ></agpr-checkbox>
                            <agpr-checkbox
                                [id]="id + '_mfMethod_mobileApp'"
                                [label]="'Mfa.'+ mfaTypesEnum.mobileApp"
                                [value]="mfaTypesEnum.mobileApp"
                                [(ngModel)]="selectedAccount.enabledMfaTypes"
                            ></agpr-checkbox>
                        </div>
                    </div>
                </agpr-panel>
                <!-- Single Sign-On -->
                <agpr-panel
                    header="Sso.amt.heading"
                    tooltip="Sso.amt.tooltip"
                >
                    <agpr-checkbox
                        [id]="id + '_ssoEnable'"
                        [binary]="true"
                        label="Sso.amt.switch"
                        [disabled]="selectedAccount.isMfaEnabled"
                        [(ngModel)]="ssoEnabled"
                        (ngModelChange)="toggleSSO()"
                    ></agpr-checkbox>
                    <div
                        *ngIf="ssoEnabled"
                        class="agpr-accountPrefs-indent"
                        role="radiogroup"
                    >
                        @for(option of ssoProviderRadioOptions; track option.provider.id) {
                            <agpr-radio
                                [id]="id + '_ssoOption_' + option.label"
                                [label]="option.label"
                                [(ngModel)]="selectedSsoProviderId"
                                [value]="option.provider.id"
                                (ngModelChange)="updateSSO($event)"
                            ></agpr-radio>
                        }
                    </div>
                </agpr-panel>
            </agpr-tab>
            <agpr-tab
                [id]="'agpr_accountPrefs_tab_discover'"
                class="agpr_accountPrefs_tab"
                heading="AMT.tab.mediaRelations"
                [disabled]="!hasTargeting && !hasNewswire"
            >
                <agpr-targeting-preferences
                    *ngIf="hasTargeting"
                    [hasMonitoring]="hasMonitoring"
                ></agpr-targeting-preferences>
                <agpr-newswire-preferences
                    *ngIf="hasNewswire"
                    (quotaAdded)="scrollToWireQuota($event)"
                ></agpr-newswire-preferences>
            </agpr-tab>
            <agpr-tab
                [id]="'agpr_accountPrefs_tab_monitor'"
                class="agpr_accountPrefs_tab"
                heading="AMT.tab.mediaIntelligence"
                [disabled]="!hasMonitoring"
            >
                @if (hasMonitoring) {
                    <agpr-monitoring-preferences
                        [hasMonitoring]="hasMonitoring"
                    ></agpr-monitoring-preferences>
                }
            </agpr-tab>
            <agpr-tab
                [id]="'agpr_accountPrefs_tab_socialListening'"
                class="agpr_accountPrefs_tab"
                heading="AMT.tab.socialListening"
                [disabled]="!hasSocial"
            >
                @if (hasSocial) {
                    <agpr-social-preferences
                        [shouldShowQuotaBanner]="this.hasMonitoring && this.hasSocial"
                        (networksError)="onNetworksErrorChange($event)"
                    ></agpr-social-preferences>
                }
            </agpr-tab>
        </agpr-tabs>

        <div class="footer">
            <agpr-action-bar>
                <ng-template #left>
                    <agpr-button
                        *ngIf="selectedAccount.id && selectedAccount.active"
                        label="AMT.header.deactivateAccount"
                        [disabled]="true"
                        [style]="buttonTypes.secondary"
                        (click)="toggleAccountActivity()"
                    ></agpr-button>
                </ng-template>
                <ng-template #right>
                    <agpr-button
                        *ngIf="selectedAccount.id && !selectedAccount.active"
                        label="AMT.header.activateAccount"
                        [disabled]="loading || isReadOnly"
                        (click)="toggleAccountActivity()"
                        [style]="buttonTypes.primaryB"
                    ></agpr-button>
                    <agpr-button
                        label="save"
                        [disabled]="isReadOnly || (hasNetworksError && hasSocial) || hasInvalidContractTimeRange"
                        (click)="accountManagementService.saveAccountChanges()"
                        [style]="buttonTypes.primary"
                        [tooltip]="hasInvalidContractTimeRange ? ('AMT.accountDetails.dateRange.invalidTime' | localize) : (hasSocial ? saveErrorTooltip : '')"
                        tooltipPosition="top"
                    ></agpr-button>
                </ng-template>
            </agpr-action-bar>
        </div>
    </div>
    <aside class="agpr-sidebar">
        <agpr-right-sidebar
            #rightSidebar
        >
            <agpr-tab
                [id]="id + '_usersTab'"
                icon=" fa-user"
                tooltip="AMT.RHP.users"
            >
                <agpr-panel
                    header="AMT.RHP.addUsers"
                    [toggleable]="false"
                    [contentPadding]="false"
                    class="agpr-accountPrefs-addUser-panel"
                >
                    <div class="agpr-accountPrefs-addUser-addOrCreateContainer">
                        <agpr-autocomplete
                            [id]="id + '_addExisting'"
                            class="agpr-accountPrefs-addUser-autocomplete"
                            placeholder="AMT.RHP.addUser.placeholder"
                            [disabled]="isReadOnly || !selectedAccount?.neptuneOnly"
                            [(ngModel)]="autocompleteSelectedUser"
                            labelField="username"
                            ariaLabel="AMT.RHP.addUsers"
                            (itemSelected)="accountManagementService.setUserToAdd($event.id)"
                            [suggestionsFetcher]="accountManagementService.searchUsersNotInAccount.bind(accountManagementService)"
                        ></agpr-autocomplete>
                        <span> {{ 'or' | localize }} </span>
                        <agpr-button
                            [id]="id + '_createUser'"
                            label="AMT.RHP.newUser"
                            class="agpr-accountPrefs-addUser-createButton"
                            [disabled]="isReadOnly || !selectedAccount?.neptuneOnly"
                            [agprTooltip]="!selectedAccount?.neptuneOnly ? 'AMT.RHP.addUser.disabled.tooltip' : null"
                            [style]="buttonTypes.tertiary"
                            (click)="openCreateContactDialog()"
                        ></agpr-button>
                    </div>
                    <div
                        *ngIf="userToAdd"
                        class="agpr-accountPrefs-userCard pending"
                    >
                        <div class="agpr-accountPrefs-userCard-left">
                            <div class="agpr-accountPrefs-userCard-name">
                                {{userToAdd.firstName}} {{userToAdd.lastName}}
                            </div>
                            <div class="agpr-accountPrefs-userCard-email">{{userToAdd.username}}</div>
                        </div>
                        <div class="agpr-accountPrefs-userCard-right">
                            <div>{{ 'AMT.RHP.userId' | localize }}</div>
                            <div
                                class="agpr-accountPrefs-userCard-id"
                                [ngClass]="{'agpr-accountPrefs-userCard-neptuneOnly': userToAdd?.neptuneOnly}"
                                [agprTooltip]="userToAdd?.neptuneOnly ? 'UMT.header.neptuneOnly.tooltip' : null"
                            >
                                {{userToAdd.id}}
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="userToAdd"
                        class="agpr-accountPrefs-addUser-addButton-container"
                    >
                        <agpr-button
                            [id]="id + '_addUser'"
                            label="AMT.RHP.addUser"
                            class="agpr-accountPrefs-addUser-addButton"
                            [disabled]="userToAdd.accountsIds.indexOf(selectedAccount.id) >= 0 || isReadOnly"
                            [tooltip]="(userToAdd.accountsIds.indexOf(selectedAccount.id) >= 0) ? ('AMT.RHP.addUser.errorMsg' | localize) : null"
                            [style]="buttonTypes.tertiary"
                            (click)="accountManagementService.addUserToSelectedAccount()"
                        ></agpr-button>
                    </div>
                </agpr-panel>

                <agpr-panel
                    *ngIf="selectedAccountUsers?.length > 0"
                    header="AMT.RHP.accountUsers"
                    [toggleable]="false"
                    [contentPadding]="false"
                >
                    <agpr-text-input
                        placeholder="AMT.RHP.filterUsers"
                        ariaLabel="AMT.RHP.filterUsers"
                        [(ngModel)]="userFilterString"
                        (ngModelChange)="filterUsers()"
                        class="agpr-accountPrefs-userFilter"
                    >
                    </agpr-text-input>
                    <div *ngFor="let user of filteredUsers" class="agpr-contextMenu-parent">
                        <div
                            class="agpr-accountPrefs-userCard"
                            [ngClass]="{'agpr-accountPrefs-userCard-inactive' : !user.isActive}"
                        >
                            <div class="agpr-accountPrefs-userCard-left">
                                <div class="agpr-accountPrefs-userCard-name">
                                    {{user.firstName}} {{user.lastName}}
                                    <span *ngIf="!user.isActive"> {{ 'AMT.RHP.inactiveUser' | localize }}</span>
                                </div>
                                <div
                                    class="agpr-accountPrefs-userCard-username"
                                    [agprTooltip]="user.username"
                                >
                                    {{ user.username }}
                                </div>
                            </div>
                            <div class="agpr-accountPrefs-userCard-right">
                                <div>{{ 'AMT.RHP.userId'| localize }}</div>
                                <div
                                    class="agpr-accountPrefs-userCard-id"
                                    [ngClass]="{'agpr-accountPrefs-userCard-neptuneOnly': user?.neptuneOnly}"
                                    [agprTooltip]="user?.neptuneOnly ? 'UMT.header.neptuneOnly.tooltip' : null"
                                >
                                    {{user.id}}
                                </div>
                            </div>
                            @if(!isReadOnly) {
                                <div class="agpr-accountPrefs-userCard-contextMenu agpr-contextMenu bottom right">
                                    @if(selectedAccount.active &&
                                        selectedAccount.neptuneOnly &&
                                        canGhostIn &&
                                        user.neptuneOnly &&
                                        currentUser.id !== user.id
                                    ) {
                                        <agpr-button
                                            [style]="buttonTypes.contextMenu"
                                            icon="fa-regular fa-duotone fa-ghost"
                                            tooltip="Ghost In"
                                            tooltipPosition="left"
                                            (click)="ghostIn(user)"
                                        ></agpr-button>
                                    }
                                    <agpr-button
                                        [style]="buttonTypes.contextMenu"
                                        icon="fa-regular fa-duotone fa-pen"
                                        tooltip="AMT.RHP.editUser"
                                        tooltipPosition="left"
                                        (click)="editUser(user)"
                                    ></agpr-button>
                                    <!--
                                        hide the remove button if the user primary account matches the selected account
                                        BE is not returning the user.primaryAccountId, so just waiting for NEP-14131 to finish and it will work
                                    -->
                                    <agpr-button
                                        *ngIf="user?.primaryAccountId !== selectedAccount?.id"
                                        [style]="buttonTypes.contextMenu"
                                        icon="fa-regular fa-duotone fa-trash-can"
                                        tooltip="AMT.RHP.removeUser"
                                        tooltipPosition="left"
                                        (click)="removeUserFromAccount(user)"
                                    ></agpr-button>
                                </div>
                            }
                        </div>
                    </div>
                </agpr-panel>
            </agpr-tab>
            <agpr-tab
                [id]="id + '.accountNotesTab'"
                icon="fa-kit-duotone fa-agpr-notes"
                [useNumberWithIcon]="true"
                tooltip="Discover.userNotes.header"
                [description]="selectedAccountNotes.length"
            >
                <agpr-account-notes
                    #accountNotes
                    [id]="id + '.accountNotes'"
                    class="agpr-accountNotes"
                    [accountNotes]="selectedAccountNotes"
                    (noteChanged)="handleNoteChange($event)"
                ></agpr-account-notes>
                <ng-template #tabFooter>
                    <agpr-action-bar>
                        <ng-template #right>
                            <ng-container
                                *ngTemplateOutlet="accountNotes.actionButtons"
                            ></ng-container>
                        </ng-template>
                    </agpr-action-bar>
                </ng-template>
            </agpr-tab>
        </agpr-right-sidebar>
    </aside>
</div>
